module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/202001/menu_all_reserving-133e3c134d25c5a241ea64e3d8b78477.png";